var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS49(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "65px",
    height: "65px",
    viewBox: "0 0 65 65",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "S49") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "S49",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 65,
    height: 65
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 65,
    height: 65
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path",
    transform: "translate(12.46, 12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.11284786,0.287942431 L14.1610073,7.33614419 C14.3447783,7.51991633 14.448948,7.77051469 14.448948,8.03094044 C14.448948,8.29136618 14.3447783,8.54196454 14.1610073,8.72573668 C13.1055523,9.78119801 11.6766588,11.2091173 10.7175117,12.1800631 C9.78686373,13.1097339 9.59129991,14.5523943 10.2408863,15.7031813 C10.2487481,15.7149741 10.2556273,15.7277497 10.2634891,15.7395426 C11.2521183,17.3237173 13.2470658,20.1815214 16.5333242,23.4668168 C19.8176171,26.7511294 22.6734385,28.7460889 24.2526901,29.7416032 C24.2664484,29.7504478 24.2792239,29.7583098 24.2929821,29.7661717 C25.4467104,30.4187101 26.8932931,30.2211797 27.8298374,29.283647 C27.8298374,29.283647 31.2743157,25.8391479 31.2743157,25.8391479 C31.4580868,25.6553758 31.7086836,25.5512055 31.9691078,25.5512055 C32.229532,25.5512055 32.4801288,25.6553758 32.6638999,25.8391479 L39.7120593,32.8873497 C39.8958303,33.0711218 40,33.3217202 40,33.5821459 C40,33.8425717 39.8958303,34.09317 39.7120593,34.2769422 C39.7120593,34.2769422 39.7120593,34.2769422 39.7120593,34.2769422 C38.687069,35.3009559 37.260141,36.7288752 36.0022431,37.9769533 C36.0012604,37.977936 36.0002776,37.9789188 35.9992949,37.9799015 C34.3345456,39.6436781 31.9347122,40.3404398 29.6390484,39.8264675 C25.242302,38.7857472 18.1459887,36.0586474 11.0437789,28.956395 C3.94156922,21.8541426 1.21448578,14.7577867 0.165909915,10.3619966 C-0.348059324,8.06337081 0.349680943,5.66155749 2.01541299,3.99581544 L5.72326373,0.287942431 C5.90703476,0.104170299 6.15763161,0 6.4180558,0 C6.67847998,0 6.92907684,0.104170299 7.11284786,0.287942431 Z",
    fill: "#4E286D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1763146,3.11724707 C29.3972961,3.11724707 36.8827717,10.6027675 36.8827717,19.8238045 C36.8827717,20.3662763 37.3230359,20.8065432 37.8655044,20.8065432 C38.4079729,20.8065432 38.8482372,20.3662763 38.8482372,19.8238045 C38.8482372,9.51880679 30.4812504,1.15176972 20.1763146,1.15176972 C19.6338461,1.15176972 19.1935818,1.59203665 19.1935818,2.1345084 C19.1935818,2.67698015 19.6338461,3.11724707 20.1763146,3.11724707 Z",
    fill: "#AC3E7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1763146,9.01367911 C26.1424852,9.01367911 30.986375,13.857598 30.986375,19.8238045 C30.986375,20.3662763 31.4266393,20.8065432 31.9691078,20.8065432 C32.5115763,20.8065432 32.9518406,20.3662763 32.9518406,19.8238045 C32.9518406,12.7726545 27.2274222,7.04820176 20.1763146,7.04820176 C19.6338461,7.04820176 19.1935818,7.48846869 19.1935818,8.03094044 C19.1935818,8.57341218 19.6338461,9.01367911 20.1763146,9.01367911 Z",
    fill: "#F89422"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1763146,14.9101111 C22.888657,14.9101111 25.0899784,17.1114458 25.0899784,19.8238045 C25.0899784,20.3662763 25.5302427,20.8065432 26.0727112,20.8065432 C26.6151797,20.8065432 27.055444,20.3662763 27.055444,19.8238045 C27.055444,16.027485 23.9726113,12.9446338 20.1763146,12.9446338 C19.6338461,12.9446338 19.1935818,13.3849007 19.1935818,13.9273725 C19.1935818,14.4698442 19.6338461,14.9101111 20.1763146,14.9101111 Z",
    fill: "#FDC124"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS49);
export default __webpack_public_path__ + "static/media/S49.8d7a2290a6a49e5093b9c8a84733a23e.svg";
export { ForwardRef as ReactComponent };